import { SquareArrowOutUpRight } from 'lucide-react';
import { renderMarkdown } from '../../utils/renderMarkdown';
import { BugKpiBlock, BugPipelinePanel } from './ExecutiveView';

function OverviewTab({ campaign, executiveData }) {
  const hasLinks = campaign.confluenceUrl || campaign.slackUrl;
  const hasMeta = campaign.leads || hasLinks;

  return (
    <div className="overview-two-col">
      {/* Left: KPIs + meta */}
      <aside className="overview-right">
        {executiveData && <BugKpiBlock data={executiveData} />}
        {hasMeta && (
          <div className="overview-meta">
            {campaign.leads && (
              <div className="overview-meta-section">
                <div className="overview-meta-label">Leads</div>
                <div className="overview-leads-pills">
                  {campaign.leads.split(',').map(lead => lead.trim()).filter(Boolean).map(lead => (
                    <span key={lead} className="overview-lead-pill">{lead}</span>
                  ))}
                </div>
              </div>
            )}
            {campaign.confluenceUrl && (
              <div className="overview-meta-section">
                <div className="overview-meta-label">Confluence</div>
                <a href={campaign.confluence_url} target="_blank" rel="noreferrer" className="overview-meta-link">
                  <SquareArrowOutUpRight size={13} />{campaign.confluence_name || 'View page'}
                </a>
              </div>
            )}
            {campaign.slackUrl && (
              <div className="overview-meta-section">
                <div className="overview-meta-label">Slack</div>
                <a href={campaign.slack_url} target="_blank" rel="noreferrer" className="overview-meta-link">
                  <SquareArrowOutUpRight size={13} />{campaign.slack_name || 'Open channel'}
                </a>
              </div>
            )}
          </div>
        )}
      </aside>

      {/* Right: pipeline + description */}
      <div className="overview-left">
        {executiveData && <BugPipelinePanel data={executiveData} />}
        {campaign.description
          ? <div
              className="overview-description"
              dangerouslySetInnerHTML={{ __html: renderMarkdown(campaign.description) }}
            />
          : <p className="overview-empty">No description provided.</p>
        }
      </div>
    </div>
  );
}

export default OverviewTab;
